// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "compiled-css" + "." + "5cb19e327805a28bbc79" + ".css";
};